import i18next from "i18next";
import { useCallback } from "react";

type LooseTFunction = (key: string, options?: Record<string, any>) => string;

export const useAppTranslation = () => {
  const t = useCallback<LooseTFunction>(
    (key, options) => {
      return (i18next.t as LooseTFunction)(key, options);
    },
    []
  );
  return {
    t,
    i18n: i18next,
  };
};
